<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("permissions.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  class="primary"
                  @click="
                    addPermissionDialog = true;
                    permission = {};
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Add Permission
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="permissions"
            :search="search"
          >
              <template v-slot:item.profile_url="{ item }">
                <v-avatar
                  size="40"
                  v-if="item && item.profile_url != null"
                  class="mb-3 mt-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + item.profile_url"
                    :alt="item.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="primary  primary--text"
                  class="white--text mb-3 mt-3"
                  size="40"
                >
                  <span class="fontsize-11 white--text">{{
                    item.name ? item.name.charAt(0) : ""
                  }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.house_number="{ item }">
                <span v-if="item.flat_name">{{ item.flat_name }}-</span>
                <span>{{ item.house_number }}</span>

                <!-- {{ item.house_number }} {{item.flat.name}} -->
              </template>
              <template v-slot:item.mobile_no="{ item }">
               
                {{ (item.country_code) }} {{ (item.mobile_no) }}

                <!-- {{ item.house_number }} {{item.flat.name}} -->
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="secondary"
                  icon
                  style="margin-left: -10px"
                  @click="
                    addPermissionDialog = true;
                    getPermissionDetail(item.id);
                  "
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_permission"
                  title="Delete "
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog
        v-model="addPermissionDialog"
        max-width="450"
        @click:outside="closeDialog"
        :loading="loading"
      >
        <v-card>
          <v-card-title class="text-h5">
            {{ permission.id ? "Edit" : "Add" }} Permission
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="permission.member_id"
                  title="member"
                  name="member"
                  label="Member"
                  :items="members"
                  item-text="name"
                  item-value="id"
                  dense
                  clearable
                  v-validate="'required'"
                  :error="
                    errors.first('member') != null ||
                      serverSideErrors.member_id != null
                  "
                  :error-messages="
                    errors.first('member') || serverSideErrors.member_id
                  "
                >
                </v-autocomplete>
                <v-select
                  v-model="permission.module_id"
                  title="module"
                  name="module"
                  label="Module"
                  :items="modules"
                  item-text="name"
                  item-value="id"
                  multiple
                  v-validate="'required'"
                  :error="
                    errors.first('module') != null ||
                      serverSideErrors.module_id != null
                  "
                  :error-messages="
                    errors.first('module') || serverSideErrors.module_id
                  "
                >
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">
              cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updatePermission(permission.id)"
              v-if="permission.id"
            >
              Update
            </v-btn>
            <v-btn color="blue darken-1" text @click="savePermission" v-else>
              save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deletePermission(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("permissions.headers.profile_url")}`,
          value: "profile_url",
          sortable: false,
          width: "10%",
        },
        {
          text: `${this.$t("permissions.headers.house_number")}`,
          value: "house_number",
          width: "15%",
        },
        {
          text: `${this.$t("permissions.headers.name")}`,
          value: "name",
          width: "13%",
        },
        {
          text: `${this.$t("permissions.headers.mobileNo")}`,
          value: "mobile_no",
          width: "15%",
        },
        {
          text: `${this.$t("permissions.headers.module")}`,
          value: "Permission",
          width: "37%",
        },
        {
          text: `${this.$t("permissions.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",
        },
      ],
      user: {},
      permissions: [],
      addPermissionDialog: false,
      editFlatDialog: false,
      deleteDialog: false,
      serverSideErrors: [],
      delete_id: "",
      flats: [],
      flat: {
        name: "",
      },
      permission: {
        id: "",
        member_id: "",
        module_id: [],
      },
      members: [],
      modules: [],
      loading: false,
    };
  },
  // watch: {
  //   addPermissionDialog() {
  //     if (!this.addPermissionDialog) {
  //       this.errors = [];
  //     }
  //   },
  // },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getPermissions() {
      let _self = this;
      _self.$axios
        .get("societyadmin/permissions?society_id=" + _self.user.id)
        .then((response) => {
          let data = response.data;
          console.log("sdfsdfsdf", data);
          if (data.status) {
            _self.permissions = data.permissions;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    getMembers() {
      let _self = this;
      _self.$axios
        .get(
          "societyadmin/members?society_id=" +
            _self.user.id +
            "&pagination=false"
        )
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.members = data.members.data;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getModules() {
      let _self = this;
      _self.$axios.get("societyadmin/modules").then((response) => {
        let data = response.data;

        if (data.status) {
          // _self.modules = data.modules;
          _self.modules = data.modules.filter(module => module.name !== "Members" && module.route !== "/members");
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    savePermission() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.permission.society_id = _self.user.id;
          this.$axios
            .post("/societyadmin/permissions", _self.permission)
            .then((response) => {
              let data = response.data;

              if (data.status) {
                // add module to the array
                // this.permissions.push(data.permission);
                this.getPermissions();
                this.closeDialog();
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};

                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  _self.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
              return;
            });
        }
      });
    },
    deletePermission(permissionId) {
      let _self = this;

      _self.$axios
        .delete("societyadmin/permissions/" + permissionId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            let index = this.permissions.findIndex((record) => {
              return record.id == permissionId;
            });

            if (index != -1) {
              this.permissions.splice(index, 1);
            }
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    closeDialog() {
      this.deleteDialog = false;
      this.addPermissionDialog = false;
      this.permission = {};
      this.$validator.reset();
      this.serverSideErrors = [];
    },
    getPermissionDetail(id) {
      let _self = this;
      _self.loading = true;
      _self.$axios
        .get("societyadmin/permissionsDetail?member_id=" + id)
        .then((response) => {
          let data = response.data;
          console.log("permission detail", data);
          if (data.status) {
            _self.permission.member_id = id;
            _self.permission.id = id;
            const arrayColumn = (arr, n) => arr.map((x) => x[n]);
            this.permission.module_id = arrayColumn(
              data.permissions,
              "module_id"
            );
            _self.loading = false;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    updatePermission(id) {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.permission.society_id = _self.user.id;
          this.$axios
            .put("/societyadmin/permissions/" + id, _self.permission)
            .then((response) => {
              let data = response.data;

              if (data.status) {
                this.getPermissions();
                this.closeDialog();
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};

                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  _self.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
              return;
            });
        }
      });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("permission_search");
      } else {
        sessionStorage.setItem("permission_search", search);
      }
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};

    this.search = sessionStorage.getItem("permission_search");
    this.getPermissions();
    this.getMembers();
    this.getModules();
  },
};
</script>
